import ahg from "../assets/companies/ahg.png";
import th from "../assets/companies/th.png";
import mycure from "../assets/companies/mycure2.png";
import slers from "../assets/companies/slers.png";
import camanco from "../assets/companies/camanco.png";
import bbi from "../assets/companies/Wordmark_BBI-Consultants.webp";
import sandlot from "../assets/companies/sandlot.png";
import tblogo from "../assets/companies/tblogo.png";
import chamly from "../assets/companies/chamly_icon.png";

export const experiences = [
  {
    id: "chamly",
    title: "Web / AI Developer",
    company: "Chamly",
    duration: "March 2026 — Present",
    year: "2026",
    current: true,
    link: "https://chamly.app/welcome",
    logo: chamly,
    stack: "Next.js, Tailwind, Supabase, AI workflows",
    bullets: [
      "Building Chamly App and Hub — wellness and money-management products on Next.js + Supabase.",
      "Owning UI, auth/data flows, and AI-assisted product features from concept to production.",
    ],
  },
  {
    id: "thinkbit",
    title: "Vue.js Developer",
    company: "ThinkBit Solutions",
    duration: "December 2024 — April 2025",
    year: "2024",
    link: "https://www.thinkbitsolutions.com/",
    logo: tblogo,
    stack: "Vue 3, Tailwind, Firebase",
    bullets: [
      "Developed Vue 3 interfaces for UNICEF-supported immunization information systems (Mobile IIS / SEIR).",
      "Integrated Firebase-backed flows for digital health tooling piloted with DOH partners.",
    ],
  },
  {
    id: "sandlot",
    title: "Software Engineer",
    company: "Sandlot",
    duration: "January 2024 — September 2024",
    year: "2024",
    link: "https://www.sandlot.ph/",
    logo: sandlot,
    stack: "Next.js, XANO, Tailwind, Vercel",
    bullets: [
      "Contributed to DOON, a fully insured P2P car-sharing marketplace for the Philippines.",
      "Shipped Next.js features against XANO APIs for listings, booking, and host experiences.",
    ],
  },
  {
    id: "bbi",
    title: "Freelance Web Developer",
    company: "BBI Consults",
    duration: "December 2023 — March 2024",
    year: "2023",
    link: "https://www.bbiconsults.com/",
    logo: bbi,
    stack: "Vite, Vue 3, Tailwind, Vercel, GoHighLevel",
    bullets: [
      "Delivered the consultancy marketing site and component system end-to-end.",
      "Owned deployment, iteration, and CRM automation support on Vercel / GoHighLevel.",
    ],
  },
  {
    id: "talent-hero",
    title: "Junior Software Engineer",
    company: "Talent Hero",
    duration: "March 2023 — January 2024",
    year: "2023",
    link: "https://talenthero.co/",
    logo: th,
    stack: "Vue 3, Tailwind, XANO",
    bullets: [
      "Built features for a global talent-acquisition platform connecting companies with vetted recruiters.",
      "Worked across Vue 3 UI and XANO-backed API integrations in a product team setting.",
    ],
  },
  {
    id: "ahg",
    title: "Vue.js Developer",
    company: "AHG Lab",
    duration: "September 2022 — March 2023",
    year: "2022",
    link: "https://www.ahglab.com/",
    logo: ahg,
    stack: "Vue 3, Tailwind, XANO",
    bullets: [
      "Built Vue 3 product surfaces for Talent Hero under AHG Lab.",
      "Collaborated with designers and backend on recruiter-facing workflows.",
    ],
  },
  {
    id: "freelance",
    title: "Freelance Web Developer",
    company: "Independent",
    duration: "June 2019 — August 2022",
    year: "2019",
    link: "",
    logo: null,
    stack: "HTML/CSS, JavaScript, Laravel, Vue, GoHighLevel",
    bullets: [
      "Shipped client sites and CRM/automation setups (including GoHighLevel) for small businesses.",
      "Handled discovery, build, and handoff solo across web and ops tooling.",
    ],
  },
  {
    id: "mycure",
    title: "Web Developer Intern",
    company: "MYCURE",
    duration: "May 2021 — July 2021",
    year: "2021",
    link: "https://www.mycure.md/",
    logo: mycure,
    stack: "Web development",
    bullets: [
      "Supported healthcare product engineering during internship — shipping UI and fixes under mentorship.",
    ],
  },
];

export const earlierRoles = [
  {
    id: "camanco",
    title: "Machine Operator",
    company: "Cavite Manufacturing Company (Camanco) Inc.",
    duration: "April 2018 — August 2018",
    year: "2018",
    link: "https://company-report.crif.com.ph/en/company/ph-PH0000014276/cavite-manufacturing-company-inc/",
    logo: camanco,
  },
  {
    id: "slers",
    title: "Sanitation Officer",
    company: "SLERS Industries, Inc.",
    duration: "March 2017 — July 2017",
    year: "2017",
    link: "http://www.slers.com/",
    logo: slers,
  },
];
